import React from "react";
import { DialogTitle, TextField } from "@mui/material";

const EditOwner = (props) => {
  const { formik } = props;

  return (
    <>
      <DialogTitle sx={{ textAlign: "center" }}>Update Owner</DialogTitle>

      <div className="grid grid-cols-1 gap-4 p-2">
        <TextField
          id="ownerName"
          fullWidth
          type="text"
          name="name"
          label="Owner Name"
          value={formik.values.owner.name}
          onChange={formik.handleChange("owner.name")}
        />

        <TextField
          id="address"
          fullWidth
          type="text"
          name="address"
          label="Owner Address"
          value={formik.values.owner.address}
          onChange={formik.handleChange("owner.address")}
        />

        <TextField
          id="email"
          fullWidth
          type="text"
          name="email"
          label="Owner Email"
          value={formik.values.owner.email}
          onChange={formik.handleChange("owner.email.0")}
        />

        <TextField
          id="contact"
          fullWidth
          type="text"
          name="contact"
          label="Owner Contact"
          value={formik.values.owner.contact}
          onChange={formik.handleChange("owner.contact.0")}
        />
      </div>
    </>
  );
};

export default EditOwner;
